import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImpactOverlayRef } from '@impactdk/ngx-overlay';

import { SettingsService } from '../../core/settings.service';
import { PanelSizes } from '../../panel/panel.component';

@Component({
    selector: 'app-terms-n-conditions-overlay',
    template: `
        <app-panel *ngIf="settingsService.get() | async as ss"
            [headerText]="ss.termsNConditions.panelHeadline"
            [panelSize]="panelSizes.SMALL">
            <app-rich-text [html]="ss.termsNConditions.panelContent"></app-rich-text>
            <app-button
                [buttonClass]="'button button--primary panel__content-button'"
                (click)="this.dialogRef.close()"
                [title]="'buttons.back' | translate"
            ></app-button>
        </app-panel>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsNConditionsOverlayComponent {
    panelSizes = PanelSizes;
    constructor(public settingsService: SettingsService, public readonly dialogRef: ImpactOverlayRef) {}
}
